import React from "react";
import { useGetPrizeStraplineTextsQuery } from "@/app/redux/features/api/winners";

const Specs = () => {
  const { data, isLoading } = useGetPrizeStraplineTextsQuery();

  if (isLoading || !data) {
    return null;
  }

  const items = [
    {
      img: "/assets/images/winners/est-icon.svg",
      mobileTitle: `${data.PrizeStraplineText1} yrs`,
      desktopTitle: `${data.PrizeStraplineText1} Years`,
      description: "UK\u2019s No.1",
    },
    {
      img: "/assets/images/winners/trophy-icon.svg",
      mobileTitle: data.PrizeStraplineText3,
      desktopTitle: `Over ${data.PrizeStraplineText3}`,
      description: "Winners",
    },
    {
      img: "/assets/images/winners/prizes-won-icon.svg",
      mobileTitle: data.PrizeStraplineText2,
      desktopTitle: data.PrizeStraplineText2,
      description: "In Prizes Won",
    },
  ];

  return (
    <div className="flex items-center shrink-0 gap-5 lg:gap-4 font-jost">
      {items.map((item, index) => (
        <React.Fragment key={index}>
          <div className="flex flex-col lg:flex-row items-start lg:items-center gap-1 lg:gap-3.5">
            <div className="flex items-center justify-center size-6 lg:size-8 shrink-0">
              <img src={item.img} alt="" width={32} height={32} className="size-[18px] lg:size-8" />
            </div>

            <div className="flex flex-col items-start">
              <div className="text-dark-1 font-jost text-xs lg:text-sm font-bold leading-4 lg:leading-[18px]">
                <span className="lg:hidden">{item.mobileTitle}</span>
                <span className="max-lg:hidden">{item.desktopTitle}</span>
              </div>

              <div className="text-gray-1 font-jost text-[10px] lg:text-xs font-medium leading-3 lg:leading-4">
                {item.description}
              </div>
            </div>
          </div>

          {index < items.length - 1 && <div className="hidden lg:block w-0.5 h-7 bg-black/10 rounded-full shrink-0" />}
        </React.Fragment>
      ))}
    </div>
  );
};

export default Specs;
